import { useAppSelector } from "@hooks/store"
import { getTableDataHelper } from "@thelpers/getTableDataHelper"
import verifyResponse from "@thelpers/verifyResponse"
import { getChargeHistoryByCharge } from "../services/GET/getChargeHistoryByCharge"
import { deleteChargeInstance } from "../services/DELETE/deleteChargeInstance"
import { useCallback } from "react"

export const useCollectionHistoryServices = () => {

    const auth = useAppSelector(state => state.auth)

    const getChargeHistoryByChargeService = useCallback(async ({ limit, skip, sort_by, sort_order, setLoading, previousData, last, currentPage, actualLimit, charge_id }) => {
        const res = await getChargeHistoryByCharge({ token: auth.idToken, company_id: auth.currentRol, limit, skip, sort_by, sort_order, charge_id })
        const status = verifyResponse({ dataResponse: res.data, statusResponse: res.status, showToast: false })
        setLoading?.(false)
        if (!status) {
            throw new Error('Error in getAllDocumentsService')
        }
        const { data, metadata } = getTableDataHelper({ data: res.data.data, metadata: res.data.metadata, skip, previousData, last, currentPage, actualLimit })
        return { data, metadata }
    }, [auth])

    const deleteChargeInstanceService = useCallback(async ({ charge_instance_id, setLoading }) => {
        const res = await deleteChargeInstance({ token: auth.idToken, charge_instance_id })
        const status = verifyResponse({ dataResponse: res.data, statusResponse: res.status, showToast: true, message: 'La instancia de cobro ha sido eliminada exitosamente' })
        if (!status) {
            setLoading?.(false)
            throw new Error('Error in deleteChargeInstanceService')
        }
        return res.data
    }, [auth])

    return {
        getChargeHistoryByChargeService,
        deleteChargeInstanceService
    }
}